import Section from '@components/common/Section/Section'
import Button from '@components/ui/Button'
import Cookies from 'js-cookie'
import { useRouter } from 'next/router'
import { FC, FormEventHandler, useEffect, useState } from 'react'

import styles from './LoginForm.module.scss'

type LoginFormProps = {
  pageId?: string
  ssrError?: string
}

const LoginForm: FC<LoginFormProps> = ({ pageId, ssrError }) => {
  const [error, setError] = useState<string | null>()
  const [loading, setLoading] = useState<boolean>()
  const { query } = useRouter()

  useEffect(() => {
    if (query.error) {
      setError(query.error as string)
    }
  }, [query])

  const submitHandler: FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault()

    const form = e.target as HTMLFormElement
    const username = (
      form.querySelectorAll("input[type='text']")[0] as HTMLInputElement
    ).value
    const password = (
      form.querySelectorAll("input[type='password']")[0] as HTMLInputElement
    ).value

    setError(null)
    setLoading(true)

    fetch('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({
        username: username,
        password: password,
        pageId: pageId,
      }),
    })
      .then((data) => data.json())
      .then((response) => {
        if (!response) {
          setError('No response.')
          setLoading(false)
          return
        }
        if (!response.success) {
          setError(response.error)
          setLoading(false)
          return
        }

        Cookies.set('gubi-session', JSON.stringify(response.token), {
          path: '/',
        })
        location.reload()
      })
  }

  return (
    <Section className={styles.container}>
      <form onSubmit={submitHandler} className={styles.root}>
        {ssrError && <p className="bodyOne mb-4">SERVER ERROR: {ssrError}</p>}
        {error && <p className="bodyOne mb-4">ERROR: {error}</p>}

        <fieldset>
          <label>Username</label>
          <input id="username" name="username" type="text" />
        </fieldset>

        <fieldset>
          <label htmlFor="password">Password</label>
          <input id="password" name="password" type="password" />
        </fieldset>

        {!loading && (
          <Button type="submit" variant="secondary" className={styles.button}>
            Login
          </Button>
        )}
        {loading && (
          <p className={`${styles.button} bodyText`}>... Authenticating</p>
        )}
      </form>
    </Section>
  )
}

export default LoginForm
